// Minimal markdown renderer used by SUX1 summary content.
// Supports: ## / ### headings, "- " bullets, "1." lists, > quotes, **bold**, *italic*,
// blank-line paragraphs and single-newline line breaks (poems). Never throws.
const escape = (s) =>
  String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const inline = (s) =>
  escape(s)
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*\w])\*(?!\s)([^*]+?)\*(?!\w)/g, "$1<em>$2</em>")
    .replace(/(^|[^_\w])_(?!\s)([^_]+?)_(?!\w)/g, "$1<em>$2</em>");

export function renderSummary(md) {
  if (typeof md !== "string" || !md) return "";
  try {
    let html = "";
    let list = null;
    let paraBuf = [];
    const flushPara = () => {
      if (paraBuf.length) {
        html += `<p>${paraBuf.map(inline).join("<br />")}</p>`;
        paraBuf = [];
      }
    };
    const closeList = () => {
      if (list) {
        html += `</${list}>`;
        list = null;
      }
    };
    const openList = (tag) => {
      if (list !== tag) {
        closeList();
        html += `<${tag}>`;
        list = tag;
      }
    };
    for (const raw of md.split(/\r?\n/)) {
      const line = (raw || "").trim();
      if (!line) {
        flushPara();
        closeList();
        continue;
      }
      const h = line.match(/^(#{1,4})\s+(.*)$/);
      if (h) {
        flushPara();
        closeList();
        const tag = h[1].length <= 2 ? "h2" : "h3";
        html += `<${tag}>${inline(h[2])}</${tag}>`;
        continue;
      }
      if (/^[-•*]\s+/.test(line)) {
        flushPara();
        openList("ul");
        html += `<li>${inline(line.replace(/^[-•*]\s+/, ""))}</li>`;
        continue;
      }
      if (/^\d+[.)]\s+/.test(line)) {
        flushPara();
        openList("ol");
        html += `<li>${inline(line.replace(/^\d+[.)]\s+/, ""))}</li>`;
        continue;
      }
      if (line.startsWith(">")) {
        flushPara();
        closeList();
        html += `<blockquote>${inline(line.replace(/^>\s?/, ""))}</blockquote>`;
        continue;
      }
      closeList();
      paraBuf.push(line);
    }
    flushPara();
    closeList();
    return html;
  } catch {
    try {
      return `<p>${escape(md)}</p>`;
    } catch {
      return "";
    }
  }
}
